import React from "react";
import { connect } from "react-redux";
import { getDesc } from "../../../stores/actions/nomenclature";

const CUFeatures = props => {

  let type = "";
  var modeldef = [
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" },
    { type: "", code: "#", desc: "#####" }
  ];
  if (
    typeof props.compare != "undefined" &&
    typeof props.compare.nomenclature != "undefined"
  ) {
   
    type = props.type;
    //if (typeof type === "undefined") type = props.type;

    var nomenclature = props.compare.nomenclature.filter(item => {
      if (item.name === type) return item;
    });
    if (nomenclature.length > 0) nomenclature = nomenclature[0];

   
    if (
      typeof props.modelnumber != "undefined" &&
      props.modelnumber.length >= 12
    ) {
    

      modeldef[0] = {
        code: props.modelnumber[0],
        type: nomenclature.nomenclature[0].type,
        desc: getDesc(
          nomenclature.nomenclature[0].trans,
          props.modelnumber[0],
          true
        )
      };
      modeldef[1] = {
        code: props.modelnumber[1],
        type: nomenclature.nomenclature[1].type,
        desc: getDesc(nomenclature.nomenclature[1].trans, props.modelnumber[1])
      };
      modeldef[2] = {
        code: props.modelnumber[2],
        type: nomenclature.nomenclature[2].type,
        desc: getDesc(nomenclature.nomenclature[2].trans, props.modelnumber[2])
      };
      modeldef[3] = {
        code:
          props.modelnumber[3] +
          props.modelnumber[4] +
          props.modelnumber[5] +
          props.modelnumber[6],
        type: nomenclature.nomenclature[3].type,
        desc: getDesc(
          nomenclature.nomenclature[3].trans,
          props.modelnumber[3] +
            props.modelnumber[4] +
            props.modelnumber[5] +
            props.modelnumber[6]
        )
      };
      modeldef[4] = {
        code: props.modelnumber[7],
        type: nomenclature.nomenclature[4].type,
        desc: getDesc(nomenclature.nomenclature[4].trans, props.modelnumber[7])
      };
      modeldef[5] = {
        code: props.modelnumber[8],
        type: nomenclature.nomenclature[5].type,
        desc: getDesc(nomenclature.nomenclature[5].trans, props.modelnumber[8])
      };
      modeldef[6] = {
        code: props.modelnumber[9],
        type: nomenclature.nomenclature[6].type,
        desc: getDesc(nomenclature.nomenclature[6].trans, props.modelnumber[9])
      };
      modeldef[7] = {
        code: props.modelnumber[10],
        type: nomenclature.nomenclature[7].type,
        desc: getDesc(nomenclature.nomenclature[7].trans, props.modelnumber[10])
      };
      modeldef[8] = {
        code: props.modelnumber[11],
        type: nomenclature.nomenclature[8].type,
        desc: getDesc(nomenclature.nomenclature[8].trans, props.modelnumber[11])
      };

     
    }
  }

  const items = modeldef.map((item, index) => {
    return (
      <React.Fragment key={item.type}>
        <li className={"key brand_Feature_K_" + index}>{item.type}</li>
        <li className={"value brand_Feature_V_" + index}>:&nbsp;&nbsp;{item.desc}</li>
      </React.Fragment>
    );
  });
  return (
    <div
      style={type == "PRO3" ? { width: "100%" } : {}}
      className="brand-features-left"
    >
      <ul>{items}</ul>
    </div>
  );
};
function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(CUFeatures);
